const ARDOQ = {};
if (window) {
  window.ARDOQ = ARDOQ;
}
export { ARDOQ };
